import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { IoIosCloudUpload } from "react-icons/io";
import { MdSmsFailed } from "react-icons/md";
const FailedMsg = ({ head, message, show, setShow }) => {
  return (
    <div
      style={{
        position: "fixed", // Viewport-based
        top: "50%", // Vertical center of screen
        left: "50%", // Horizontal center
        transform: "translate(-50%, -50%)", // Perfect centering
        zIndex: 1055, // Above most Bootstrap elements
      }}
    >
      <Toast show={show} onClose={() => setShow(false)} delay={3000} autohide>
        <Toast.Header className="bg-danger text-white">
          <strong className="me-auto ">
            <MdSmsFailed /> {head}
          </strong>
        </Toast.Header>
        <Toast.Body className="bg-danger-subtle text-success-emphasis">
          <b>{message}</b>
        </Toast.Body>
      </Toast>
    </div>
  );
};
export default FailedMsg;
